
/**
 * @file FormCheckout
 */
'use strict';

/**
 * @classname FormCheckout
 * @classdesc 
 */
export default class FormCheckout {
	/**
	 * @constructor
	 * @param {object} controller - コントローラー
	 */
	constructor(controller){
		this._controller = controller;
	};


	/**
	 * フォーム送信前処理
	 *
	 * @memberof FormCheckout
	 * @return {undefined}
	 */
	postProcessing($form) {
		console.log(`${this.constructor.name}.postProcessing`);

		const birthYear = $('#birth_year').val();
		const birthMonth = $('#birth_month').val();
		const birthDay = $('#birth_day').val();
		$('#birthday').val(`${birthYear}/${birthMonth}/${birthDay}`);

		// ギフト内祝い設定
		$('.celebration_message_birth_year').each((idx, e) => {
			const $year = $(e);
			const $wrap = $year.closest('.form-group__content');
			const year = $year.val();
			const month = $wrap.find('.celebration_message_birth_month').val();
			const day = $wrap.find('.celebration_message_birth_date').val();
			$wrap.find('.celebration_message_birthday').val(`${year}/${month}/${day}`);
		});

		if(!$('.celebration_message').prop('checked')){
			console.log('内祝い名入れを設定しない');
			$('.celebration_message_gender').prop('checked', false);
		}else{
			console.log('内祝い名入れを設定する');
		}

		this._controller.completePostProcessing($form);
	};
}
